import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import { useRouter } from 'next/router'

const resource = createResource({
  en: {
    title: 'About Kredit Pintar',
    desc: `PT Kredit Pintar Indonesia is a fintech (financial technology) company that has a vision to improve the lives of Indonesians by providing easy access to short-term loans. With leading AI (Artificial Intelligence) technology, we want to work with the community to improve Indonesia's welfare.`,
  },
  id: {
    title: 'Tentang Perusahaan Kredit Pintar',
    desc: `PT Kredit Pintar Indonesia adalah perusahaan fintech (financial technology) yang memiliki visi untuk meningkatkan kehidupan masyarakat Indonesia melalui penyediaan akses yang mudah untuk mendapatkan pinjaman jangka pendek. Dengan teknologi AI (Artificial Intelligence) terdepan, kami ingin bekerja sama dengan masyarakat untuk meningkatkan kesejahteraan Indonesia.`,
  },
})

const AboutBanner = () => {
  const { t } = useResource(resource)
  const [isFromeMe, setFromeMe] = useState(false)
  const router = useRouter()

  useEffect(() => {
    const path = router.asPath
    const query = router.query.isFrom || ''
    if (path.includes('about-us') && query === 'me') {
      setFromeMe(true)
    }
  }, [router.asPath])

  return (
    <BannerBox showPadding={isFromeMe}>
      <div className="container">
        <div className="left">
          <h1 className="title">{t('title')}</h1>
        </div>
        <p className="right">{t('desc')}</p>
      </div>
    </BannerBox>
  )
}

export default AboutBanner

type IBannerBox = {
  showPadding: boolean
}

const BannerBox = styled.div<IBannerBox>`
  @media only screen and (max-width: 1000px) {
    padding-top: ${(props) => `${props.showPadding ? '0' : '62px'}`};
    .container {
      position: relative;
      height: 586px;
      width: 100%;
      margin: 0 auto;
      .left {
        width: 100%;
        height: 586px;
        background-image: url('/images/about/mobile-about-bg1.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 0 24px;
        .title {
          padding-top: 24px;
          margin: 0;
          font-size: 28px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.87);
          line-height: 32px;
        }
      }
      .right {
        position: absolute;
        top: 98px;
        left: 24px;
        width: 272px;
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #757575;
        line-height: 20px;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 100px auto 0;
    .container {
      height: 600px;
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      .left {
        position: relative;
        width: 100%;
        height: 410px;
        background-image: url('/images/about/about-bg1.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 0 150px;
        .title {
          padding-top: 95px;
          width: 390px;
          font-size: 44px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.87);
          line-height: 68px;
        }
      }
      .right {
        padding: 20px 150px;
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #757575;
        line-height: 36px;
      }
    }
  }
`
